import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const CHRegister = lazyRouteComponent(() => import('../pages/ch-register'))

export const chRegisterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/ch-register',
  component: CHRegister,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
